import { Handler, IframeSelectionPayload } from "../common/types";
import { IframeEvents, MsgBusActions } from "../common/events";
import { WIDGET_METADATA } from "../common/config";
import {
  getPopularBetBuilderBetListName,
  getPopularBetBuilderEventCategory,
  getAccaBetListName,
  getAccaTrackingEvent,
} from "../common/utils";
import { logger } from "../services/logger";
import { track } from "@sb/analytics";

export const removeFromIframe: Handler<IframeSelectionPayload> = (
  payload,
  { msgBus, stateMngr, iframe },
) => {
  logger.log(`[From Iframe] ${IframeEvents.REMOVE_FROM_SLIP}: `, payload);

  const widgetType = iframe.getWidgetType();
  const metadata = WIDGET_METADATA[widgetType];

  if (metadata.requiresGtpMapping) {
    const id = stateMngr.handleRemoveFromIframe(payload);
    track({
      EventName: "popular_BetBuilder_remove",
      EventAction: "Remove from Betslip",
      EventLabel: payload.analytics.accaName,
      EventCategory: getPopularBetBuilderEventCategory(),
      BetListName: [getPopularBetBuilderBetListName()],
    });
    msgBus.publish(MsgBusActions.REMOVE_FROM_SLIP, id);
    logger.log(`[To MsgBus]: ${MsgBusActions.REMOVE_FROM_SLIP}: `, id);
  } else {
    const accaPayload = payload as any;
    track({
      EventName: getAccaTrackingEvent(widgetType, "remove"),
      EventAction: "Remove from Betslip",
      EventLabel: accaPayload.analytics?.accaName,
      BetListName: [getAccaBetListName(widgetType)],
    });
    accaPayload.selections?.forEach((selection: any) => {
      const id = selection.selectionId.replace("OB_OU", "");
      msgBus.publish(MsgBusActions.REMOVE_FROM_SLIP, id);
      logger.log(`[To MsgBus]: ${MsgBusActions.REMOVE_FROM_SLIP}: `, id);
    });
  }
};
